import styled from 'styled-components'
import { iPadDown } from '../../../styles/mediaQueries'

const ErrorIcon = styled.svg`
  width: auto;
  height: 1.02vw;

  ${iPadDown} {
    height: 3.14vw;
  }

  path {
    fill: currentColor;
    stroke: currentColor;
  }
`

export default ErrorIcon
